import React, { useEffect, useRef, useState } from 'react';
import {I_IQPlayerGallery} from "./../interfaces";
import {I_IQPlayerGallerySettings} from "../interfaces";
interface I_IQPS_ImagesProps {
    item: I_IQPlayerGallery;
    iQPlayerGallerySettings: I_IQPlayerGallerySettings
}

const IQPS_Images: React.FC<I_IQPS_ImagesProps> = ( props: I_IQPS_ImagesProps ) => {

    const item = props?.item

    return (
        <div className="text-center rounded-xl overflow-hidden">
            <img className="bg-gray-400" src={item?.img}/>
            <div className="text-gray-700 py-4 px-4" style={{backgroundColor: item?.bgColor}}>
                <div className="text-xl font-bold" style={{color: item?.color}}> {item?.title}</div>
                <div className="text-sm"  style={{color: item?.color}}> {item?.title}</div>
                <div className="text-base"  style={{color: item?.color}}> "Voice ReGen made our remote interviews sound like they were done in person. Game-changer!"</div>
            </div>
        </div>
    );
};

export default IQPS_Images;